import type { FC } from "react";

import { Column } from "@hightouch/htui";

import { UsagePanel } from "src/components/lineage/usage-panel";

type Props = {
  resourceType: string;
  resourceId: string;
};

// Fixed height so the surrounding dialog keeps its size while the tree loads
// and expands.
export const DependencyTree: FC<Props> = ({ resourceType, resourceId }) => (
  <Column
    height={72}
    borderWidth="hairline"
    borderColor="base.border"
    borderRadius="md"
    overflow="hidden"
  >
    <UsagePanel
      variant="tree"
      resourceType={resourceType}
      resourceId={resourceId}
      fillHeight
      alwaysRefetch
    />
  </Column>
);
